import Vue from 'vue';
import iView from 'iview';
import { router } from './router/index';
import store from './store';
import App from './app.vue';
import 'amfe-flexible'
import Components from '@/components-mall'
import { getQueryString } from './util/index'
import './plugin'
import { changeLanguage } from './util/locationutil';
import i18n from '@/util/lang'
import { NumFormat,formatTime} from '@/util/index'
// 积分商城-注册全局组件
Vue.use(Components)

// 自定义主题
import Vant, { Lazyload } from 'vant'

Vue.use(Vant)
Vue.use(Lazyload)

import Watermark from 'ywl-watermark-vue'
Vue.use(Watermark)  

changeLanguage(getQueryString('lang') || localStorage.getItem('language') || `zh_CN`, i18n)

// Toast.allowMultiple()
import 'vant/lib/index.less'
import 'vant/lib/icon/local.less'
Vue.prototype.$store = store;
Vue.prototype.$NumFormat = NumFormat;
Vue.prototype.$formatTime = formatTime;
Vue.prototype.$eventBus = new Vue()
Vue.use(iView);


import AMap from 'vue-amap';
Vue.use(AMap);

// 初始化vue-amap
AMap.initAMapApiLoader({
    // 高德key
    key: 'f3c7a3994fa61ddcf4c33b5d6b149c6f',
    // 插件集合 （插件按需引入）
    plugin: ['AMap.Geolocation']
    //AMap.Geolocation定位服务插件。融合了浏览器定位、高精度IP定位、安卓定位sdk辅助定位等多种            手段，提供了获取当前准确位置、获取当前城市信息、持续定位(浏览器定位)等功能。
});





export default new Vue({
    el: '#app',
    router: router,
    i18n,
    render: h => h(App),
});


// WEBPACK FOOTER //
// src/main.js